import { SidebarTrigger } from "@/components/ui/sidebar"
import { cn } from "@/lib/utils"
import { useIsMobile } from "@/hooks/use-mobile"

interface PageHeaderProps {
  title: string
  description?: string
  eyebrow?: string
  className?: string
  children?: React.ReactNode
}

const PageHeader = ({ title, description, eyebrow, className, children }: PageHeaderProps) => {
  const isMobile = useIsMobile()
  
  return (
    <div className={cn("mb-5 flex flex-col gap-4 md:mb-6 md:flex-row md:items-center md:justify-between", className)}>
      <div className="flex items-start gap-3">
        {isMobile && (
          <SidebarTrigger className="mt-0.5 shrink-0 md:hidden" />
        )}
        <div className="min-w-0 space-y-1.5 md:space-y-2">
          {eyebrow && <p className="section-kicker">{eyebrow}</p>}
          <h1 className="font-display text-[1.75rem] font-semibold leading-tight tracking-[-0.02em] md:text-[2.35rem] md:leading-none">
            {title}
          </h1>
          {description && (
            <p className="max-w-xl text-sm leading-6 text-muted-foreground md:max-w-2xl md:text-base">
              {description}
            </p>
          )}
        </div>
      </div>
      <div className="flex w-full items-center gap-2 self-start md:w-auto">
        {children}
      </div>
    </div>
  )
}

export { PageHeader }
